import { AgGridModule } from '@ag-grid-community/angular';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';
import { CdwSearchGridModule } from '@cdw-ae/common-ui-components-search-grid';

@Component({
  selector: 'jobs-device-profile-wipe',
  imports: [
    CommonModule,
    MaterialLibraryModule,
    CdwIconModule,
    CdwSearchGridModule,
    AgGridModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
  ],
  templateUrl: './jobs-device-profile-wipe.component.html',
  styleUrls: ['./jobs-device-profile-wipe.component.scss'],
})
export class JobsDeviceProfileWipeComponentComponent {}
